/**
 * line heights of each tag + padding, per Article Text and Typography designs
 */
export const ReadingTime = {
    h2: 48,
    h3: 36,
    h4: 44,
    p: 12,
    pPadding: 12,
    articleBlok: 48,
    img: 88,
    bottomPadding: 48,
};
